// TypeScript
import axios, { AxiosResponse } from "axios";

function isDateArray(a: any): a is number[] {
  return Array.isArray(a)
    && a.length >= 3
    && a.length <= 7
    && a.every((n: any) => typeof n === "number")
    && a[0] > 1900 && a[0] < 3000; // año plausible
}

function toISOFromArray(arr: number[]): string {
  const [y, m, d, hh = 0, mm = 0, ss = 0, ns] = arr;
  const ms = typeof ns === "number" ? Math.floor(ns / 1_000_000) : 0;
  // En JS el mes es 0–11
  const date = new Date(Date.UTC(y, (m ?? 1) - 1, d, hh, mm, ss, ms));
  return date.toISOString().replace('Z', ''); // quita 'Z' si quieres tratarlo como local
}

function normalizeDatesDeep(obj: any): any {
  if (obj == null) return obj;

  if (isDateArray(obj)) {
    return toISOFromArray(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(normalizeDatesDeep);
  }

  if (typeof obj === "object") {
    const out: any = {};
    for (const k of Object.keys(obj)) {
      out[k] = normalizeDatesDeep(obj[k]);
    }
    return out;
  }

  return obj;
}

axios.interceptors.response.use((response: AxiosResponse) => {
  const responseType = response.config.responseType;

  if (
    responseType === 'blob' ||
    responseType === 'arraybuffer' ||
    response.data instanceof Blob ||
    response.data instanceof ArrayBuffer
  ) {
    return response;
  }

  response.data = normalizeDatesDeep(response.data);
  return response;
});
